// Wannasorn tutor companies: 1000001 chemou, 1000002 appliedphysics, 1000003 biobeam.
// These companies share the extended learner form (Thai/English names, grade level, parent phone).
export const WANNASORN_COMPANY_IDS = [1000001, 1000002, 1000003];

// Company ids arrive as both numbers (store) and strings (localStorage), so coerce before matching.
export const isWannasornCompany = (companyId) =>
  WANNASORN_COMPANY_IDS.includes(Number(companyId));
